import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

// consts and libs
const Com = styled.span`
	font-size: 16px;
	font-weight: 400;
	line-height: 32px;
	@media (max-width: 800px) {
		font-size: 15px;
		line-height: 30px;
	}

	${p => p.webConfig.dir === 'ltr' && `
		direction: ltr !important;
		text-align: left;
	`}
	${p => p.c && `
		color: ${p.c};
	`}

	${p => p.s && `
		font-size: ${p.s};
	`}

	${p => p.w && `
		font-weight: ${p.w};
	`}
`;

const Text = props => {
	const {
		tag,
		color,
		weight,
		size,
		children,
		className,
		...rest
	} = props;
	const {webConfig} = useSelector(state => state.core);

	return (
		<Com
			webConfig={webConfig}
			{...rest} 
			as={tag} 
			c={color} 
			w={weight} 
			s={size}
			className={className}
		>
			{children}
		</Com>
	);
};

/* Props ================================== */
Text.propTypes = {
	tag: PropTypes.oneOf([
		'div',
		'span',
		'p',
		'a',
		'h1',
		'h2',
		'h3',
		'h4',
		'h5',
		'h6',
		'strong',
	]),
	color: PropTypes.string,
	weight: PropTypes.number,
	size: PropTypes.string,
	children: PropTypes.node,
	className: PropTypes.string,
};

Text.defaultProps = {
	tag: 'span',
	color: null,
	weight: null,
	size: null,
	children: null,
	className: '',
};

/* Export ================================== */
export default Text;
